// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Anguilla from '../_raw/flag/icon_flag_anguilla.png';

export default () => <img src={Anguilla} alt="Anguilla" />;
